import { Fragment } from "react";

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import constants from "../../assets/constants";

const NumberScaleAnswerOption = styled("span")(({ theme, smallScreen, pillarColor }) => ({
  margin: "0px",
  padding: "0px",
  width: smallScreen ? "30px" : "48px",
  height: smallScreen ? "30px" : "48px",
  backgroundColor: theme.palette.foreground.main,
  color: alpha(pillarColor, 0.75),
  borderColor: alpha(pillarColor, 0.5),
  borderWidth: "1px",
  borderStyle: "solid",
  "input:hover ~ &": {
    color: pillarColor,
    backgroundColor: alpha(pillarColor, 0.15),
  },
  "input:checked ~ &": {
    backgroundColor: pillarColor,
    color: theme.palette.primary.contrastText,
    borderColor: pillarColor,
  },
}));

const CheckedNumberScaleAnswerOption = styled(NumberScaleAnswerOption)(
  ({ theme, pillarColor }) => ({
    "input:hover ~ &": {
      backgroundColor: alpha(pillarColor, 0.7),
    },
  }),
);

const NumberScaleAnswerOptionText = styled(Typography)(({ smallScreen }) => ({
  height: "100%",
  width: "100%",
  textAlign: "center",
  marginTop: smallScreen ? "-1px" : "2px",
}));

const QuestionNumberScaleDisplay = props => {
  const theme = useTheme();

  const getBusinessPillarColor = businessPillarEnum => {
    switch (businessPillarEnum) {
      case constants.empirePillarEnumes.leadership:
        return theme.palette.highlight.main;
      case constants.empirePillarEnumes.opertations:
        return theme.palette.error.main;
      case constants.empirePillarEnumes.marketing:
        return theme.palette.warning.main;
      case constants.empirePillarEnumes.finance:
        return theme.palette.success.main;
      case constants.empirePillarEnumes.personnel:
        return theme.palette.info.main;
      default:
        return theme.palette.primary.main;
    }
  };

  const { question, onAnswerSelected, startNextTimer } = props;

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  const defaultDelay = 350;

  return (
    <Fragment>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={question.answerValue}
          name="radio-buttons-group"
          row
        >
          {question.answerOptions.map((answerOption, index) => (
            <FormControlLabel
              id={`numberScaleAnswerOptionLabel-${index}`}
              key={`numberScaleAnswerOptionLabel-${index}`}
              value={answerOption.value}
              sx={{
                paddingLeft: "0px",
                paddingRight: "0px",
                marginLeft: "0px",
                marginRight: "-1px",
              }}
              control={
                <Radio
                  disableRipple
                  sx={{ paddingLeft: "0px", paddingRight: "0px", margin: "0px" }}
                  id={`numberScaleAnswerOption-${index}`}
                  key={`numberScaleAnswerOption-${index}`}
                  onChange={e => {
                    e.stopPropagation();
                    onAnswerSelected([answerOption.value]);
                    startNextTimer(defaultDelay);
                  }}
                  icon={
                    <NumberScaleAnswerOption
                      smallScreen={smallScreen}
                      pillarColor={getBusinessPillarColor(question.shortTitle)}
                    >
                      <NumberScaleAnswerOptionText
                        variant={smallScreen ? "h5" : "h4"}
                        smallScreen={smallScreen}
                        pillarColor={getBusinessPillarColor(question.shortTitle)}
                      >
                        {answerOption.text}
                      </NumberScaleAnswerOptionText>
                    </NumberScaleAnswerOption>
                  }
                  checkedIcon={
                    <CheckedNumberScaleAnswerOption
                      smallScreen={smallScreen}
                      pillarColor={getBusinessPillarColor(question.shortTitle)}
                    >
                      <NumberScaleAnswerOptionText
                        variant={smallScreen ? "h5" : "h4"}
                        smallScreen={smallScreen}
                        pillarColor={getBusinessPillarColor(question.shortTitle)}
                      >
                        {answerOption.text}
                      </NumberScaleAnswerOptionText>
                    </CheckedNumberScaleAnswerOption>
                  }
                />
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Fragment>
  );
};

export default QuestionNumberScaleDisplay;
